import React from 'react'
import styled from 'styled-components'
import { colors } from '../../colors'

const FaqCard = ({question, answer, category}) => {
  return (
    <Container>
        <h4>{question}</h4>
        <small>{answer}</small>

    </Container>
  )
}

const Container = styled.div`

    display: flex;
    max-width: 1250px;
    width: 100%;
    flex-direction: column;
    padding: 30px 16px;
    background-color: ${colors.white};
    /* border: 1px solid; */
    border-bottom: 1px solid #D0D5DD;

    cursor: pointer;

    @media screen and (max-width: 600px){
      width: 90%;
      margin: 0 auto;
      padding: 20px 0px;
    }

    & > h4{
        font-size: 1.8rem;

        @media screen and (max-width: 600px){
          font-size: 1.4rem;
          font-weight: 600;
        }
    }

    & > small{
        font-size: 1.4rem;

        @media screen and (max-width: 600px){
          font-size: 1.2rem;
          
        }
    }
    `

export {FaqCard}